/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'world': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10.012 2A8 8 0 1110 2h-.014zm6.94 8.514h-3.071a10.5 10.5 0 01-2.52 6.324 6.974 6.974 0 005.591-6.324zm-10.833 0H3.048a6.975 6.975 0 005.592 6.324 10.495 10.495 0 01-2.521-6.323zm6.731 0h-5.7a9.466 9.466 0 002.85 6.27 9.47 9.47 0 002.85-6.27zM8.64 3.163l-.045.009a6.974 6.974 0 00-5.547 6.315h3.071a10.5 10.5 0 012.52-6.324zm1.362.055l-.116.112A9.456 9.456 0 007.15 9.485h5.7a9.47 9.47 0 00-2.848-6.268zm1.358-.055l.096.113a10.493 10.493 0 012.425 6.21h3.071a6.974 6.974 0 00-5.592-6.323z" _fill="#1D3861" fill-rule="evenodd"/>'
  }
})
